export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_11.a04ed609.jpg";